export default __webpack_public_path__ + "static/media/vip1.89a1af9b.webp";